import { Tooltip } from "antd";
import { useState } from "react";
import References from "../../helpers/Reference";

export const Button = (props) => {

    const [ isTooltipOpened, setIsTooltipOpened ] = useState(false);

    const onClick = () => {
        setIsTooltipOpened(false)
        if (props?.handleClick)
            props.handleClick();
    }

    const onHandleTooltipOpenChange = (newState) => {
        setIsTooltipOpened(newState);
    }

    return (
        <Tooltip 
            open={isTooltipOpened}
            onOpenChange={onHandleTooltipOpenChange}
            title={props?.tooltip?.title} 
            placement={props?.tooltip?.placement || "left"} 
            color="white" 
            overlayInnerStyle={{color: "black"}}
            mouseEnterDelay={props?.tooltip.delay || References.tooltip_delay}
        >
        <div 
            id={props?.id}
            style={{
                left: props?.position?.left, 
                right: props?.position?.right,
                top: props?.position?.top,
                bottom: props?.position?.bottom,
                backgroundImage: `url(${props?.icon})`,
                backgroundPositionX: 'center'
            }}
            className={
                `position-absolute-btn 
                ${props?.type}
                ${props?.size}                `
            }            
            onClick={onClick}
            onDoubleClick={props?.handleDoubleClick}
        >

        {props?.children}
        {props?.title}
        </div>   
        </Tooltip>    );
}